import script from "./SkipLink.vue?vue&type=script&setup=true&lang=ts"
export * from "./SkipLink.vue?vue&type=script&setup=true&lang=ts"

import "./SkipLink.vue?vue&type=style&index=0&id=24c71e08&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-24c71e08"]])

export default __exports__